require('./tabLink.scss');
const PropTypes = require('prop-types');
const React = require('react');
const {
    Component
} = require('react');
const className = require('classnames');
const { Link } = require('react-router-dom');

class TabLink extends Component {

    render() {
        const { label, isSelected, customClassName, link, onClick, locator } = this.props;

        const classNamesLabel = className('ok-tab__label', {
            'is-selected': isSelected
        });

        const classNamesMarker = className('ok-tab__marker', {
            'is-selected': isSelected
        });

        const classNameComponent = className('ok-tab', {
            [customClassName]: !!customClassName
        });

        const locatorName = `btn${locator}`;
        return (
            <li className={classNameComponent} onClick={onClick}>
                <Link
                    id={locatorName}
                    className="ok-tab__link"
                    to={link}
                >
                    <span className={classNamesLabel}>
                        {label}
                    </span>
                    <hr className={classNamesMarker}></hr>
                </Link>
            </li>
        );
    }
}

TabLink.propTypes = {
    customClassName: PropTypes.string,
    isSelected: PropTypes.bool,
    label: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]).isRequired,
    link: PropTypes.string,
    locator: PropTypes.string,
    onClick: PropTypes.func
};

TabLink.defaultProps = {
    isSelected: false
};

module.exports = TabLink;